<template>
  <section>
    <div class="section_title">
      <h1 class="">よくあるご質問</h1>
    </div>
    <h3 class="mt-5">ご注文について</h3>
    <dl class="list-qa">
      <dt v-on:click="openInfo('1')" :class="{'is-active': isActive[1]}">（初回の）注文方法を教えてください。</dt>
      <dd v-show="isActive[1]">FAX、郵送、会員サイト（ホームページ）でのご注文が可能です。<br>※「会員登録申込書兼商品注文書」でのご注文となります。</dd>
      <dt v-on:click="openInfo('2')" :class="{'is-active': isActive[2]}">（2回目以降の）注文方法を教えてください。</dt>
      <dd v-show="isActive[2]">
        FAX、電話、会員サイト（ホームページ）でご注文いただけます。<br>
        電話：営業日9時から16時<br>
        FAX・会員サイト（ホームページ）：24時間 年中無休<br>
        （いずれも営業日16時以降のご注文は翌営業日の出荷になります）
      </dd>
      <dt v-on:click="openInfo('3')" :class="{'is-active': isActive[3]}">ツール品のみの注文はできますか？</dt>
      <dd v-show="isActive[3]">ツール品のみでのご注文はできません。通常商品1個以上のご注文と合わせてお願いいたします。</dd>
      <dt v-on:click="openInfo('4')" :class="{'is-active': isActive[4]}">支払方法を教えてください。</dt>
      <dd v-show="isActive[4]">代金引換、銀行振込（事前のお振込）でお支払いいただけます。<br>来社購入される場合は、現金でお支払いいただけます。<br>当ホームページの会員サイトからご購入いただく場合は、クレジットカードでもお支払いいただけます。<br>※クレジットカードでのご購入は1回払いのみとなります。<br>※ご本人様名義のクレジットカードをご利用ください。</dd>
      <dt v-on:click="openInfo('5')" :class="{'is-active': isActive[5]}">代金引換手数料について教えてください。</dt>
      <dd v-show="isActive[5]">¥300が必要です。<br>新規入会時のご購入のみ無料です。</dd>
      <dt v-on:click="openInfo('6')" :class="{'is-active': isActive[6]}">送料はかかりますか？</dt>
      <dd v-show="isActive[6]">1回のご注文（ツール品を含む）で1万円（税込）以上の場合、無料です。<br>1万円未満の場合は全国一律700円の配送費をいただきます。</dd>
      <dt v-on:click="openInfo('7')" :class="{'is-active': isActive[7]}">自宅以外に商品を送ってもらえますか？</dt>
      <dd v-show="isActive[7]">ご自宅、別送先にもお送りできます。別送先をご指定いただく場合には、別送先の住所をご記入ください。<br>※商品のお届けは、日本国内に限らせていただきます。</dd>
      <dt v-on:click="openInfo('8')" :class="{'is-active': isActive[8]}">発送のタイミングを教えてください。</dt>
      <dd v-show="isActive[8]">営業日の16:00までに受付されたご注文分については原則として宅配便により当日出荷、営業日16:00時以降もしくは土日祝日に到着したご注文分は翌営業日出荷となります。<br>ただし、初回ご注文の場合は、入会審査などの手続き上、ご注文受付日の翌営業日以降の出荷となることがあります。</dd>
    </dl>
    <h3 class="mt-5 pt-5">ポイントについて</h3>
    <dl class="list-qa">
      <dt v-on:click="openInfo('9')" :class="{'is-active': isActive[9]}">ポイントについて教えてください。</dt>
      <dd v-show="isActive[9]">商品及びツール品を購入することでそれぞれに設定されているポイントが付与されます。<br>貯まったポイントは、次回の買い物で1ポイント＝1円として商品及びツール品のご購入にご使用していただけます。</dd>
      <dt v-on:click="openInfo('10')" :class="{'is-active': isActive[10]}">ポイントの還元率を教えてください</dt>
      <dd v-show="isActive[10]">原則として商品・ツール品それぞれの購入代金の1％相当のポイントが設定されています。<br>また、送料や代金引換手数料にはポイントの還元はございません。<br>※還元率は商品によって異なります。</dd>
      <dt v-on:click="openInfo('11')" :class="{'is-active': isActive[11]}">ポイントはどのタイミングで付与されますか。</dt>
      <dd v-show="isActive[11]">出荷確定後は仮ポイントとして付与されますが、仮ポイントの状態ではご使用できません。<br>出荷日の深夜に仮ポイントは使用できるポイントに変更されます。</dd>
      <dt v-on:click="openInfo('12')" :class="{'is-active': isActive[12]}">エコポイントとは何ですか？</dt>
      <dd v-show="isActive[12]">エコ対象商品をご購入していただく事で、より多くのポイント付与させていただきます。</dd>
      <dt v-on:click="openInfo('13')" :class="{'is-active': isActive[13]}">送料や代金引換手数料にポイントは使えますか？</dt>
      <dd v-show="isActive[13]">送料や代金引換手数料にはポイントの利用はできません。</dd>
      <dt v-on:click="openInfo('14')" :class="{'is-active': isActive[14]}">ポイントの有効期限を教えてください。</dt>
      <dd v-show="isActive[14]">ポイント付与日の翌年度の3月31日16:00までとなります。</dd>
    </dl>
  </section>
</template>

<script>
export default{
  data: () => {
    return {isActive: []}
  },
  mounted (){
    window.scroll(0, 0);
    for(let i = 0; i < 100; i++) {
        this.isActive[i] = false
    }
  },
  methods: {
    openInfo(ref) {
      console.log(ref)
      this.isActive[ref] = !this.isActive[ref]
      console.log(this.isActive[ref])
    },
  }
}
</script>